(function () {

    "use strict";

    angular.module('harriApp')
        .controller("AssignTagsModalController", AssignTagsController);

    AssignTagsController.$inject = ['$q', '$scope', 'tagsDataService', 'modalData', 'hFormsService', '$filter'];

    function AssignTagsController ($q, $scope, tagsDataService, modalData, hFormsService, $filter) {

        var self = this;

        self.brandId = modalData.brandId;
        self.modalData = modalData;
        self.loading = false;
        self.invalidCandidates = false;

        var assignTagsForm = hFormsService.getForm('AssignTagsForm');
        self.assignTagsForm = new assignTagsForm($scope, 'assign-tags-form');

        self.getCandidatesIds = function (candidates) {
            return self.modalData.candidates ? _.pluck(candidates, 'id'): [];
        };

        self.onSelectedCandidatesChanged = function () {
            self.invalidCandidates = !(self.modalData && self.modalData.candidates && self.modalData.candidates.length);
        };

        var init = function () {
            var defer = $q.defer();
            var promises = {};

            self.isLoading = true;
            self.candidates = self.modalData.candidates;
            self.modalData.candidates = angular.copy(self.candidates);

            promises['brandTagsGroupedByMode'] = tagsDataService.getByBrandId(self.brandId, true);

            $q.all(promises)
                .then(function (res) {
                    defer.resolve();

                    if (res && res.brandTagsGroupedByMode) {
                        self.modalData['tags'] = res.brandTagsGroupedByMode;
                    }

                    self.assignTagsForm.loadData(self.modalData);
                    self.assignTagsForm.setBrandId(self.brandId);
                })
                .catch(function (err) {
                    defer.reject();
                    console.error(err);
                })
                .finally(function () {
                    self.isLoading = false;
                });
        };

        init();

        self.hideModal = function () {
            self.modalData = {};
            self.loading = false;
            modalData.onHide && modalData.onHide();
            $scope.$hide();
        };

        self.save = function () {
            self.loading = true;
            var tags = self.assignTagsForm.selectedTags || [];
            var candidatesIds = self.getCandidatesIds(self.modalData.candidates);

            if (!self.assignTagsForm.invalidCandidates && !_.isEmpty(candidatesIds) && tags && tags.length) {
                self.assignTagsForm.save(candidatesIds, tags)
                    .then(function () {
                        self.hideModal();
                    })
                    .catch(function (err) {
                        console.error(err);
                        hAlert({
                            title: $filter("translate")("Error"),
                            text: $filter("translate")("Something went wrong!"),
                            custom_class: 'rejection-templates-error-alert',
                            button: {text: "Okay"}
                        });
                    })
                    .finally(function () {
                        self.loading = false;
                    });
            } else {
                self.loading = false;
                console.error('missing data: Assign Form');
            }
        };
    }

})();